import { ActionContextMenuIcons, ActionContextSvgIcons, getBrandIcon, } from '@office-start/action-context-menu-icons';
import { ActionContextMenuItemIcon, } from '@office-start/document-types';
import React, { useMemo } from 'react';
import { useActionMenuIconStyles } from './ActionMenuIcon.styles';
/**
 * Container for v9 Fluent icons
 */
var ActionContextMenuIconContainer = function (_a) {
    var icon = _a.icon, className = _a.className, isDisabled = _a.isDisabled;
    var styles = useActionMenuIconStyles();
    var actionContextMenuIcon = useMemo(function () {
        return ActionContextMenuIcons[icon.iconName]({
            className: className,
            /* Do not set primaryFill. If you do, it will not get auto adjusted in high contrast mode */
            primaryFill: undefined,
        });
    }, [className, icon]);
    var iconSpan = (React.createElement("span", { className: "".concat(styles.iconContainer, " ").concat(isDisabled ? styles.disabledIcon : styles.icon) }, actionContextMenuIcon));
    return iconSpan;
};
var IconUrlContainer = function (_a) {
    var iconUrl = _a.iconUrl;
    var styles = useActionMenuIconStyles();
    return (React.createElement("img", { className: styles.urlIconSize, src: iconUrl, 
        // TODO: add localization for alt text #7768405
        alt: "Action Context Menu Icon" }));
};
var maybeGetContentActionIcon = function (_a) {
    var _b;
    var icon = _a.icon, className = _a.className, _c = _a.brandStyles, brandStyles = _c === void 0 ? { size: '16' } : _c, isDisabled = _a.isDisabled, _d = _a.svgStyles, svgStyles = _d === void 0 ? {
        width: '20',
        height: '20',
        viewBox: '0 0 20 20',
        fill: 'none',
    } : _d;
    if (!icon) {
        return null;
    }
    // Icon will render itself in a custom fashion
    if (icon.type === ActionContextMenuItemIcon.RenderIcon) {
        return icon.renderIcon();
    }
    // All icons require a className to be passed (svg, brand, and fluent)
    if (!className) {
        return null;
    }
    switch (icon.type) {
        // Fluent v9 subset for action menu
        case ActionContextMenuItemIcon.ActionContextMenuIcon:
            return (React.createElement(ActionContextMenuIconContainer, { icon: icon, className: className, isDisabled: isDisabled }));
        // Brand icon
        case ActionContextMenuItemIcon.Brand:
            return ((_b = getBrandIcon({
                size: brandStyles.size,
                fileType: icon.fileType,
                className: "".concat(className, " ").concat(brandStyles.className),
            })) !== null && _b !== void 0 ? _b : (React.createElement(ActionContextMenuIconContainer, { icon: {
                    iconName: 'OpenIcon',
                    type: ActionContextMenuItemIcon.ActionContextMenuIcon,
                }, className: className })));
        // SVG
        case ActionContextMenuItemIcon.Svg:
            return ActionContextSvgIcons[icon.iconName]({
                viewBox: svgStyles.viewBox,
                fill: svgStyles.fill,
                height: svgStyles.height,
                width: svgStyles.width,
                className: className,
            });
        case ActionContextMenuItemIcon.Url:
            return React.createElement(IconUrlContainer, { iconUrl: icon.iconUrl });
        // Unsupported...
        default:
            return null;
    }
};
export var ActionMenuIcon = function (props) {
    return maybeGetContentActionIcon(props);
};
//# sourceMappingURL=ActionMenuIcon.js.map